import {
  useState,
  forwardRef,
  useEffect,
  useRef,
  useImperativeHandle,
} from "react";
import queryString from "query-string";
import { Dialog, Box, Divider, Slide } from "@mui/material";

// 팝업효과
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function RegisterFormHelp(props) {
  const { open, closeClick, openClick } = props;

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={closeClick}
        TransitionComponent={Transition}
      >
        <Box
          sx={{
            width: "90%",
            textAlign: "left",
            padding: "30px 0 10px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <img src="/img/back_button_black.png" onClick={closeClick} />
          <Box
            sx={{
              margin: "25px 0 0 10px",
              fontSize: "22px",
            }}
          >
            추천인 제도
          </Box>
        </Box>
        <Divider />
        <Box
          sx={{
            background: "#f1f2f2",
            margin: "20px",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <Box
            sx={{
              fontWeight: "bold",
            }}
          >
            추천인 제도란?
          </Box>
          <br></br>
          <Box
            sx={{
              fontSize: "14px",
            }}
          >
            가입자와 추천인 모두 큰 혜택을 받을 수 있는 제도입니다.
            <br></br>
          </Box>
          <br></br>
          <br></br>
          <Box
            sx={{
              fontWeight: "bold",
            }}
          >
            추천인 혜택
          </Box>
          <br></br>
          <Box
            sx={{
              fontSize: "14px",
            }}
          >
            신규 가입자(추천인 작성자)는 5% 할인쿠폰을 받을 수 있습니다.
            <br></br>
            추천인은 5000 캐쉬 적립됩니다.
          </Box>
        </Box>
      </Dialog>
    </>
  );
}

export default RegisterFormHelp;
